import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MonthResource } from '~/generated';
import { analyticsGetMonthReports } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

export const useMonthReports = (
  options?: Omit<
    UseQueryOptions<
      MonthResource[],
      unknown,
      MonthResource[],
      ['monthReports']
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    queryKey: ['monthReports'],
    queryFn: () => extractData(analyticsGetMonthReports()),
    ...options,
  });
};
